
<template>
  <div class="flex" :style="'width:880px;margin:10px auto;padding:20px;background-color:' + value.backgroundColor.hex + ';'">
    <div style="margin-right:10px;flex: 1;">
      <div class="image-parent">
        <img :src="value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'" />

        <div class="image-uploader">
          <button @click="changeImage" style="margin-left:10px;">CHANGE IMAGE</button>
        </div>

      </div>
      <input v-model="value.caption" placeholder="Enter a caption..." />
      <input v-model="value.source" placeholder="Enter a source..." />
      <slider-picker v-model="value.backgroundColor" style="margin-top:10px;margin-bottom:10px;" />
      <input v-model="value.backgroundColor.hex" placeholder="Hex colour" />
    </div>
    <div style="flex: 1;">
      <froala-editor :config="froalaConfig" v-model="value.wysiwyg" style="width:100%;margin:0;min-height: 100%;"></froala-editor>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
require("firebase/firestore");
import FroalaEditor from "./Froala";
import { Slider } from 'vue-color'

export default {
  components: { FroalaEditor, 'slider-picker': Slider},
  data: function() {
    return {
      storage: firebase.storage(),
      froalaConfig: {
            imageDefaultWidth: 0,
            toggleModal: this.toggleModal,
            toolbarButtons: 	{
              'moreText': {
                'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
              },
              'moreParagraph': {
                'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
              },
              'moreRich': {
                'buttons': ['insertLink','insertImage', 'insertTable', 'emoticons',  'specialCharacters','insertHR'],
                'buttonsVisible': 3
              },
              'moreMisc': {
                'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                'align': 'right',
                'buttonsVisible': 2
              }
            },
          immediateVueModelUpdate: false,
          vueIgnoreAttrs: null
        }
    }
  },
  props:{
      value:{
          type: Object,
          required:true
      },
  },
  created() {
    if(!this.value.backgroundColor) Vue.set(this.value,"backgroundColor", {hex:"#fff"});
  },
  methods: {
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function() {
      this.$emit('changeImage', {
        callback: (images) => {
          this.value.image = images
        }
      })
    }
  }
  
}
</script>
<style>
.image-uploader {
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
  background-color: rgba(0,0,0,0.6);
  justify-content:center;
  align-items: center;
  display:none;
}
.image-parent:hover .image-uploader {
  display:block;
  display:flex;
}
</style>
<style scoped>
img {
  height: 400px;
  width: 100%;
  object-fit: cover;
}
.image-parent {
  position:relative;
}


input {
  width:100%;
}

</style>


// WEBPACK FOOTER //
// imageFeatured.vue?224f1ccd